import { ITipInterceptor } from '@tencent/pmd-types';
import { MessagePlugin } from 'tdesign-vue-next';
import { useUserStore, LoginStatus } from '@/store';
import router from '@/router';
import { RetCode } from '../contants';
import { userIsLogin } from '../common';
import { isInvalidSupplier } from '../common';

// 不需要权限的路由
const NotAuthRouteList = ['Register', 'Login'];

export class LoginInfoInterceptor implements ITipInterceptor {
  interceptor(res: any): [boolean, any] {
    let stop = false;
    // 无权限
    if (
      !userIsLogin(res.data?.ret) ||
      (isInvalidSupplier(res.data?.ret) && router.currentRoute.value.name !== 'Login')
    ) {
      stop = true;
      // 确保router.currentRoute获取到的是最新的页面路由
      router.isReady().then(() => {
        const { loginStatus } = useUserStore();
        if (loginStatus === LoginStatus.unready || loginStatus === LoginStatus.success) {
          const { name, fullPath } = router.currentRoute.value;
          if (isInvalidSupplier(res.data?.ret)) {
            if (name === 'Register') return;
          } else {
            if (NotAuthRouteList.includes(name as string)) return;
          }

          useUserStore().setLoginStatus(LoginStatus.fail);
          useUserStore().resetUserInfo();
          let msg = res.data?.err_msg || res.data?.msg;
          if (!msg || res.data.ret === RetCode.NotLogin) {
            msg = $t('登录状态已过期');
          }
          MessagePlugin.closeAll();
          MessagePlugin.error(msg);
          router.replace({
            path: '/login',
            query: { redirect_url: encodeURIComponent(fullPath) },
          });
        }
      });
    }
    return [stop, res];
  }
}
